export default {
  name: 'User Preferences',
  htmlId: 'userPreferences',
};
